import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
// import axios from 'axios';
import api from "../../redux/actions/api";
import { baseURL } from "../../util/server";

const PaymentModeDropdown = ({
  value,
  onChange,
  label = "Payment Mode",
  error = false,
  helperText = "",
  hideAdvancedAdjustment = false,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api({ auth: true })
      .get(`${baseURL}/getall/clinic/payment/methods`)
      .then((res) => {
        // Adjust this if the API response structure is different
        const reqList =
          res.data?.data?.length > 0
            ? res.data?.data?.map((li) => ({
                name: li?.name,
                value: li?.name,
              }))
            : [];
        if (!hideAdvancedAdjustment) {
          reqList.unshift({
            name: "Advance Adjustment",
            value: "advanceAdjustment",
          });
        }
        setOptions(reqList);
      })
      .catch(() => setOptions([]))
      .finally(() => setLoading(false));
  }, []);
  // To center the placeholder text, we can use InputProps and InputLabelProps to apply styles.
  // We'll add sx to the TextField for input and label alignment.
  // This component is meant to mimic the UI usage in CommonAdvancePayModalComponent.js:
  // <Select list={UserPaymentTypeList} value={userValues.paymentMode} handleChange={(e, value) => handleValueChange(value, "paymentMode")} name="paymentMode" error={!!usrErrs.paymentMode} helperText={usrErrs.paymentMode} search />
  // So, provide a similar interface for PaymentModeDropdown:
  // - Accepts: list, value, handleChange, name, error, helperText, search
  // - Renders an Autocomplete dropdown with error and helperText support

  // Accept props similar to Select for compatibility
  // (list, value, handleChange, name, error, helperText, search)
  // Already handled: value, onChange, label, ...props
  // We'll map 'list' to options, 'handleChange' to onChange, and pass error/helperText to TextField
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option?.name || ""}
      value={value}
      onChange={(e, newValue) => {
        onChange(newValue);
      }}
      loading={loading}
      error={error}
      helperText={helperText}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      {...props}
    />
  );
};

export default PaymentModeDropdown;
